import { useAuth } from "@canucci/base/auth";
import type { MfaStepUpErrorDetail } from "@canucci/base/auth/mfaStepUpError";
import { subscribeMfaStepUpRequired } from "@canucci/base/auth/mfaStepUpSignal";
import { useEffect, useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import MfaRemediationPage from "@/pages/MfaRemediationPage";

/** Mounted around routes, but only a structured server refusal can activate it. */
export default function MfaRefusalBoundary({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();
  const path = location.pathname + location.search;
  const [refusal, setRefusal] = useState<{ detail: MfaStepUpErrorDetail; path: string; userId?: string } | null>(null);
  useEffect(() => {
    setRefusal(null);
    return subscribeMfaStepUpRequired((signal) => {
      if (signal?.detail && signal.userId && signal.userId === user?.uid) {
        setRefusal({ detail: signal.detail, path, userId: user?.uid });
      }
    });
  }, [path, user?.uid]);
  if (refusal && refusal.path === path && refusal.userId === user?.uid) {
    return <MfaRemediationPage detail={refusal.detail} onRetry={() => setRefusal(null)} />;
  }
  return children;
}
